import React, { useState } from "react";
import { connect } from "react-redux";
import { Link, useLocation } from "react-router-dom";

// Resources
import HamburgerIcon from "../../resources/hamburger-white.svg";
import SnowScapeLogoWithWhiteText from "../../resources/logo/snowscape-logo-horizontal-with-white-text.svg";
import ButtonLink from "../Buttons/ButtonLink";

const LandingNavBar = (props) => {
  const location = useLocation();

  const [displayMobileMenu, setDisplayMobileMenu] = useState(false);

  const menuBarItems = !props.currentUser?.uid
    ? [
        {
          label: "Business Health Quiz",
          url: "https://info.mysnowscape.com/quiz-landing-page",
        },
        { label: "Login", url: "/admin-login" },
        { label: "Sign Up", url: "/sign-up", button: true },
      ]
    : [
        { label: "Docs", url: "/docs" },
        { label: "Dashboard", url: "/admin" },
      ];

  const navItems = [
    { label: "Home", url: "/" },
    { label: "About", url: "/#about-us" },
    { label: "Pricing", url: "/#pricing" },
    { label: "Features", url: "/#features" },
    { label: "Tutorials / Demos", url: "/docs" },
    { label: "FAQ", url: "/faq" },
    { label: "Contact", url: "/#contact-us" },

    ...(!props.currentUser?.uid
      ? [
          {
            label: "Login",
            url: "/admin-login",
            spaceBefore: true,
          },
        ]
      : [
          {
            label: "Dashboard",
            url: "/admin",
            spaceBefore: true,
          },
        ]),
  ];

  const handleHamburgerClicked = () => {
    setDisplayMobileMenu(!displayMobileMenu);
  };

  return (
    <nav className="w-full fixed h-20 bg-landing-page-black 2xl:px-20 px-4 flex z-40 drop-shadow-2xl">
      <div className="flex justify-between w-full max-w-[2000px] m-auto">
        {/* Snowscape Logo */}
        <Link to="/" className="flex">
          <img
            alt="snowscape-logo"
            className="my-auto"
            src={SnowScapeLogoWithWhiteText}
          />
        </Link>

        <div id="nav-right" className="flex gap-5">
          {/* Desktop Menu */}
          <div className="hidden lg:flex flex-row justify-between my-auto font-bold text-snow-white items-center">
            {menuBarItems.map((item, key) =>
              item.button ?? false ? (
                <ButtonLink
                  key={key}
                  to={item.url}
                  className="w-auto px-3 pt-2 pb-2 mx-auto"
                >
                  Try For Free
                </ButtonLink>
              ) : (
                <Link
                  className={`xl:mx-4 mx-2 hover:underline whitespace-nowrap ${
                    location.pathname === item.url ? "" : ""
                  } ${item.spaceBefore ? "ml-3 pl-5 border-l-[1px]" : ""} ${item.label === "Home" ? "hidden xl:inline" : ""}`}
                  key={key}
                  to={item.url}
                >
                  {item.label}
                </Link>
              ),
            )}
          </div>

          {/* Mobile Hamburger Menu */}
          <div
            className="self-center cursor-pointer "
            onClick={handleHamburgerClicked}
          >
            <img alt="hamburger-menu" className="" src={HamburgerIcon} />
          </div>
          {/* Mobile Dropdown Menu */}
          <ul
            className={`fixed  w-full left-0 top-20 bg-snow-white float-right text-center transition-all duration-700 ${
              displayMobileMenu
                ? "h-screen overflow-scroll"
                : "h-0 overflow-hidden"
            }`}
          >
            {navItems.map((item, key) => (
              <li
                className={`leading-8 m-10 transition-all text-xl uppercase select-none font-bold  
                              ${item.spaceBefore ? "pt-10 border-t-[1px]" : ""}`}
                key={key}
              >
                <Link
                  className={`mx-3 hover:opacity-50 ${
                    location.pathname === item.url
                      ? "text-snow-green"
                      : "text-snow-primary"
                  }`}
                  onClick={handleHamburgerClicked}
                  to={item.url}
                >
                  {item.label}
                </Link>
              </li>
            ))}
            <>
              {props.currentUser?.uid ? null : (
                <li
                  className={`leading-8 m-10 transition-all text-xl uppercase select-none font-bold text-snow-white`}
                >
                  <ButtonLink
                    to="/sign-up"
                    className="w-auto px-3 pt-2 pb-2 mx-auto"
                    onClick={handleHamburgerClicked}
                  >
                    Try For Free
                  </ButtonLink>
                </li>
              )}
            </>
          </ul>
        </div>
      </div>
    </nav>
  );
};

const mapStateToProps = (state) => {
  const { currentUser } = state;
  return { currentUser };
};

export default connect(mapStateToProps)(LandingNavBar);
